import { useTranslation } from "react-i18next";
import { Target, Eye, Users2, Heart } from "lucide-react";

export default function AboutUs() {
  const { t, i18n } = useTranslation();

  const values = [
    {
      icon: Users2,
      title: t("about.teamTitle"),
      members: [
        {
          name: t("about.agneseName"),
          photo: "https://customer-assets.emergentagent.com/job_3c7f87e1-2a24-4f0f-adf0-0a2e7782581c/artifacts/k0lwhc2y_5E38C196-93D9-4127-9D97-334DD11544AA.jpeg",
          description: t("about.agneseDesc")
        },
        {
          name: t("about.didzisName"),
          photo: "https://customer-assets.emergentagent.com/job_3c7f87e1-2a24-4f0f-adf0-0a2e7782581c/artifacts/gqk78y4r_0A3EA30B-D939-4305-9440-D68E7D9C3686.jpeg",
          description: t("about.didzisDesc")
        }
      ]
    },
    { icon: Target, title: t("about.missionTitle"), description: t("about.missionDesc") },
    { icon: Eye, title: t("about.visionTitle"), description: t("about.visionDesc") },
    { icon: Heart, title: t("about.valuesTitle"), description: t("about.valuesDesc") }
  ];

  return (
    <section id="par-mums" className="section-spacing bg-white" data-testid="about-us-section">
      <div className="section-container">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div>
            <span className="inline-block bg-primary/10 text-primary px-4 py-2 rounded-full text-sm font-semibold mb-4">{t("about.badge")}</span>
            <h2 className="text-3xl md:text-5xl font-bold text-foreground mb-6" style={{ fontFamily: 'Manrope, sans-serif' }}>{t("about.title")}</h2>
            <p className="text-lg text-primary font-semibold mb-4">{t("about.subtitle")}</p>
            <p className="text-lg md:text-xl text-muted-foreground mb-8 leading-relaxed">{t("about.desc1")}</p>
            <p className="text-lg text-muted-foreground mb-10 leading-relaxed">{t("about.desc2")}</p>

            <div className="space-y-6">
              {values.map((value, index) => (
                <div key={index} className="flex gap-4" data-testid={`about-value-${index + 1}`}>
                  <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center flex-shrink-0">
                    <value.icon className="w-6 h-6 text-primary" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-foreground mb-1" style={{ fontFamily: 'Manrope, sans-serif' }}>{value.title}</h3>
                    {value.description && (
                      <p className="text-muted-foreground leading-relaxed">{value.description}</p>
                    )}
                    {value.members && (
                      <div className="space-y-4 mt-3">
                        {value.members.map((member, mIndex) => (
                          <div key={mIndex} className="flex items-start gap-4">
                            {member.photo && (
                              <img src={member.photo} alt={member.name} className="w-16 h-16 rounded-xl object-cover flex-shrink-0" loading="lazy" />
                            )}
                            <div>
                              <p className="font-semibold text-foreground">{member.name}</p>
                              <p className="text-sm text-muted-foreground leading-relaxed">{member.description}</p>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl img-zoom">
              <img src="https://customer-assets.emergentagent.com/job_senior-care-10/artifacts/cd7cw7ti_IMG_9718.JPG" alt="SIA Drošā vide komanda — senioru drošības uzraudzības speciālisti Latvijā" className="w-full h-[500px] object-cover" loading="lazy" />
            </div>
            <div className="absolute bottom-6 left-6 right-6 bg-white/95 backdrop-blur-sm rounded-2xl p-6 shadow-lg">
              <h4 className="font-bold text-foreground mb-4 text-center" style={{ fontFamily: 'Manrope, sans-serif' }}>{t("about.contactTitle")}</h4>
              {i18n.language === 'es' ? (
                <div className="text-center">
                  <p className="text-sm text-muted-foreground mb-1">{t("about.phone")}</p>
                  <a href="tel:+34610042815" className="text-primary font-semibold hover:underline text-lg">+34 610 042 815</a>
                </div>
              ) : (
                <div className="grid grid-cols-2 gap-4 text-center">
                  <div>
                    <p className="text-sm text-muted-foreground mb-1">{t("about.phone")}</p>
                    <a href="tel:+37129173338" className="text-primary font-semibold hover:underline">+371 29173338</a>
                    <p className="text-xs text-muted-foreground mt-1">Agnese Bērziņa</p>
                  </div>
                  <div>
                    <p className="text-sm text-muted-foreground mb-1">{t("about.phone")}</p>
                    <a href="tel:+37125775533" className="text-primary font-semibold hover:underline">+371 25775533</a>
                    <p className="text-xs text-muted-foreground mt-1">Didzis Tupureins</p>
                  </div>
                </div>
              )}
            </div>
            <div className="absolute -top-6 -right-6 w-32 h-32 bg-primary/10 rounded-full blur-3xl" />
          </div>
        </div>
      </div>
    </section>
  );
}
